import { Address } from './address';
import { Person } from './person';

export class PersonAddress extends Address {
  person: Person = null;

  constructor() {
    super();
  }
}
